// Uploads go to our own server (POST /upload), which stores them on the
// VPS and returns a public URL. Replaces direct uploads to Supabase Storage.
// authFetch (installed in index.js) adds the signed-in user's token.
const API = (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/$/, "");

// Base for files the app ships with (puja audio, verse cards). Defaults to the
// old Supabase bucket so nothing breaks before migration; set
// REACT_APP_MEDIA_BASE_URL=https://api.vedsanga.com/media once files are moved.
export const MEDIA_BASE = (process.env.REACT_APP_MEDIA_BASE_URL ||
  "https://bghnhmcnraljjahuaggp.supabase.co/storage/v1/object/public").replace(/\/$/, "");

export async function uploadMedia(bucket, fileOrBlob, filename = "upload") {
  const form = new FormData();
  form.append("bucket", bucket);
  form.append("file", fileOrBlob, filename);
  const res = await fetch(`${API}/upload`, { method: "POST", body: form });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Upload failed (${res.status})`);
  return data.url;
}
